import React, {useCallback, useEffect, useState} from 'react'
import {Unity, useUnityContext} from "react-unity-webgl";
import {useToken} from "../../hooks/api";

const WEBGL_BASE = process.env.REACT_APP_WEBGL_BASE_URL || '/webgl';

const StarpathGL = ({experience, title, binaryName="WebGL"}) => {
    const {getToken} = useToken();
    const [unityReady, setUnityReady] = useState(undefined);

    const {unityProvider, sendMessage, addEventListener, removeEventListener} = useUnityContext({
        loaderUrl: `${WEBGL_BASE}/${experience}/Build/${binaryName}.loader.js`,
        dataUrl: `${WEBGL_BASE}/${experience}/Build/${binaryName}.data.gz`,
        frameworkUrl: `${WEBGL_BASE}/${experience}/Build/${binaryName}.framework.js.gz`,
        codeUrl: `${WEBGL_BASE}/${experience}/Build/${binaryName}.wasm.gz`,
        streamingAssetsUrl: `${WEBGL_BASE}/${experience}/StreamingAssets`,
        companyName: "Doubling Technologies",
        productName: `Starpath - ${title}`,
        showBanner: false,
    });
    const [windowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const initUnity = useCallback((webglComponent) => {
        setUnityReady(webglComponent);
    }, []);

    useEffect(() => {
        if(!unityReady) return;
        async function send() {
            console.log("Received WebGLInit event from " + unityReady);
            const token = await getToken();
            try {
                sendMessage(unityReady, "SetToken", token);
            } catch (e) {
                console.error(e);
            }
        }

        send();
    }, [unityReady])

    useEffect(() => {
        addEventListener("WebGLInit", initUnity);

        return () => {
            removeEventListener("WebGLInit", initUnity);
        }
    }, [addEventListener, removeEventListener, initUnity]);

    return (
        <>
            <Unity unityProvider={unityProvider} style={{
                width: windowSize.width-25,
                height: windowSize.height-200,
                marginTop: "-15px",
                marginBottom: "-15px",
            }} />
        </>
    )
}

export default StarpathGL